import type { SxProps, Theme } from '@mui/material';

export const outlinedInputStyles: SxProps<Theme> = {
  height: 35,
  bgcolor: 'white.main',
  borderRadius: '8px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey.400',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
  },
};

export const filterFontSize = '0.8125rem';

export const getFilterSelectStyles = (isActive: boolean): SxProps<Theme> => ({
  ...outlinedInputStyles,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: isActive ? 'primary.main' : 'divider',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: isActive ? 'primary.main' : 'grey.400',
  },
  '& .MuiSelect-select': {
    py: 0.625,
    fontSize: filterFontSize,
    color: isActive ? 'primary.main' : 'text.secondary',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: isActive ? 500 : 400,
  },
  '& .MuiSelect-icon': {
    color: isActive ? 'primary.main' : 'inherit',
  },
});

export const menuItemStyles: SxProps<Theme> = {
  py: 0.5,
  px: 1,
};

export const checkboxStyles: SxProps<Theme> = {
  p: 0.5,
  mr: 1,
  color: 'grey.400',
  '&.Mui-checked': { color: 'primary.main' },
};
